var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.invitees),function(invitee,key){return _c('Invitee',_vm._b({key:key},'Invitee',invitee,false),[(_vm.editable)?[_c('span',{staticClass:"icon-remove",on:{"click":function($event){return _vm.$emit('removed', key)}}},[_c('i',{staticClass:"fas fa-minus-circle"})])]:_vm._e()],2)}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-496f06bb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Booking/Invites/List.vue
// module id = null
// module chunks = 